import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { presentPhoneNumber } from '../../utils/phone';

export default function PurchaseSuccessModal({ phones, onClose }: { phones: string[]; onClose: () => void }) {
  const cardRef = useRef<HTMLDivElement>(null);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    linkRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { event.preventDefault(); closeRef.current(); }
      if (event.key !== 'Tab') return;
      const controls = Array.from(cardRef.current?.querySelectorAll<HTMLElement>('a[href], button') || []);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);

  return createPortal(<div className="u2-modal is-open sms-purchaseModal" role="presentation">
    <div className="u2-modalBackdrop" aria-hidden="true" onMouseDown={onClose} />
    <div ref={cardRef} className="u2-modalCard sms-purchaseModal__card sms-purchaseSuccess" role="dialog" aria-modal="true" aria-labelledby="purchase-success-title">
      <div className="u2-modalHeader sms-purchaseModal__header"><h2 id="purchase-success-title">{phones.length === 1 ? 'Номер куплен' : 'Номера куплены'}</h2></div>
      <div className="u2-modalBody sms-purchaseModal__body">
        <div className="sms-purchaseSuccess__numbers">{phones.map((phone, index) => <p key={`${phone}-${index}`}>{presentPhoneNumber(phone).displayFullNumber}</p>)}</div>
        <div className="sms-longRent__confirmActions">
          <button type="button" className="u2-btn is-secondary" onClick={onClose}>Продолжить покупки</button>
          <a ref={linkRef} className="u2-btn is-primary" href={`/sms/active-numbers#number-${presentPhoneNumber(phones[0]).fullNumber.replace(/\D/g, '')}`}>Перейти в мои номера</a>
        </div>
      </div>
    </div>
  </div>, document.body);
}
